import { PickListDesignTokens } from '@primeng/themes/types/picklist';

export default {
    root: {
        gap: '1.125rem',
    },
    controls: {
        gap: '0.5rem',
    },
    css: ({ dt }) => `
    .p-picklist-transfer-controls > button:nth-child(2) {
        display: none;
    }

    .p-picklist-transfer-controls > button:nth-child(4) {
        display: none;
    }

    .mazars-list-picker-disabled > .p-picklist-transfer-controls > button {
        display: none;
    }
    `,
} as PickListDesignTokens;
